import React from 'react';
import { motion } from 'framer-motion';
interface BonusCardProps {
  title: string;
  description: string;
  imageUrl: string;
  delay?: number;
}
export function BonusCard({
  title,
  description,
  imageUrl,
  delay = 0
}: BonusCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-[#F0EAD6] rounded-xl overflow-hidden shadow-lg border-2 border-[#8B7355]/20 flex flex-col h-full" data-id="element-1">
      <div className="relative h-64 overflow-hidden bg-[#E6DCC3]" data-id="element-2">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-3" />
        <div className="absolute top-4 right-4 bg-[#D97706] text-white px-3 py-1 rounded-full text-sm font-bold shadow-md" data-id="element-4">
          GRATIS HOY
        </div>
      </div>
      <div className="p-6 flex-1 flex flex-col" data-id="element-5">
        <h3 className="font-serif text-xl font-bold text-[#2C5F2D] mb-3" data-id="element-6">
          {title}
        </h3>
        <p className="text-gray-700 text-sm leading-relaxed flex-1" data-id="element-7">
          {description}
        </p>
      </div>
    </motion.div>;
}